export const languages = {
	en: {
		name: "English",
		code: "EN",
		flag: require('@/assets/img/US.svg'),
		welcome: "Welcome to the application",
		hello: "Hello!",
		goodbye: "Goodbye!",
		no_record_found: "No results found",
		menu: {
			collection: "The Collection",
			search: "Search",
			contact: "Contact"
		},
		page_home: {
			hero_slider: {
				title: "Thesaurus of Greek literature",
				subtitle: "Thesaurus of Greek Literature from the Collection of Athanasios Oikonomopoulos"
			},
			section_1: {
				title: "Bibliotheca Graeca",
				paragraph_1: "Bibliotheca Graeca is the name that came to be used for the body of texts by Greek authors who lived from the time of Homer to the fall of Constantinople. The name is drawn from the monumental work of the same title by Albertus Fabricius, compiled in the early 18th century. Albertus Fabricius (1668–1736), a native of Leipzig, first conceived the idea of compiling the Bibliotheca Graeca at the age of 20 while working in the library of Samuel Schmidt. After completing various studies, including a doctoral thesis on Platonism in the work of Philo of Alexandria, he became a librarian at the library of the theologian Johann Friedrich Mayer in Hamburg—considered one of the largest private libraries of its time. There, he encountered a vast number of editions of Greek works and decided to catalogue their contents along with information on the authors, works, editions, manuscripts, and more. The result of his many years of labor was the 14-volume work titled Bibliotheca Graeca.",
				paragraph_2: "Emulating Fabricius, Sakos Ikonomopoulos undertook the task of collecting all editions of the texts mentioned in Fabricius’s Bibliotheca Graeca that were published up to the early 20th century. This collection now includes more than 6,000 titles and is electronically accessible at the present site.",
				button_1: "THE COLLECTOR",
				button_2: "CONTACT"
			},
			section_2: {
				title: "Catalogue of the Collection <br>& Thesaurus of Literature",
				paragraph_1: "The database made available to the public through this website includes a detailed record of all the book titles in the collection, which can be searched using any element of their identity, such as the author’s name, a word from the title, the publisher, the year of publication, etc.",
				paragraph_2: "A unique feature of this database is that it includes photographic material for all the books, making it a valuable tool for research and study.",
				paragraph_3: "In addition, it is accompanied by an encyclopedic thesaurus containing information about the lives of the authors and their literary work.",
				paragraph_4: "With the search button below, you can explore the full range and depth of the collection, learn details about the editions of the literature, and search for the information that interests you.",
				button_1: "SEARCH"
			}
		},
		page_collector: {
			title: "",
			paragraph_1: "Sakos (Athanasios) Ikonomopoulos (b. Thessaloniki, 1953) is an engineer, researcher, entrepreneur and author. ",
			paragraph_2: "He studied Mechanical and Electrical Engineering at the National Technical University of Athens and earned a Docteur Ingénieur diploma from Pierre et Marie Curie University, Paris (1980). He conducted pioneering research on neural networks for computer vision at CNRS and later taught (1981-1985) image processing at the École Polytechnique Fédérale de Lausanne, where he co-authored a landmark IEEE paper on image-coding techniques. ",
			paragraph_3: "He directed the pilot robotics program of the European Union’s ESPRIT initiative and, in 1988, founded ZENON Robotics, which implemented more than 50 industrial applications in Greece, Cyprus, and Germany before being listed on the Athens Stock Exchange. ",
			paragraph_4: "Alongside his academic and entrepreneurial career, he has built the collection Bibliotheca Graeca presented in this site,  and has published over 25 scientific papers and several books on Greek literature, philosophy, and mathematics."
		},
		page_search: {
			title: "",
			code: "CODE",
			category: "CATEGORY",
			author: "AUTHOR",
			short_title: "SHORT TITLE",
			description: "DESCRIPTION",
			date_of_writing: "DATE OF WRITING:",
			example: "(e.g. –800 to –600)",
			from: "from",
			to: "to",
			date_of_publication: "DATE OF PUBLICATION:",
			place_of_writing: "PLACE OF WRITING",
			place_of_birth: "PLACE OF BIRTH",
			result: "RESULTS"
		},
		single_card: {
			author: "Author:",
			publisher: "Publisher:",
			category_of_Work: "Category of Work:",
			book_code: "Book Code:"
		},
		page_book_profile: {
			title: "Title Page",
			btn_back: "BACK",
			btn_new_search: "NEW SEARCH",
			description: "Description",
			book_code: "Book Code"
		},
		page_thesaurus: {
			title: "",
			btn_back: "BACK",
			description: "Description",
			wikipedia: "Wikipedia",
			dictionary: "SOUDAS Dictionary"
		}
	},
	el: {
		name: "Greek",
		code: "EL",
		flag: require('@/assets/img/GR.svg'),
		welcome: "Καλώς ήρθατε στην εφαρμογή",
		hello: "Γειά σας!",
		goodbye: "Αντίο!",
		no_record_found: "Δεν βρέθηκαν Αποτελέσματα",
		menu: {
			collection: "Η συλλογή Α. Οικονομόπουλου",
			search: "Αναζήτηση",
			contact: "Επικοινωνία"
		},
		page_home: {
			hero_slider: {
				title: "Θησαυρός της ελληνικής γραμματείας",
				subtitle: "Ο Θησαυρός της ελληνικής γραμματείας <br> από την συλλογή βιβλίων του <br> Αθανασίου Οικονομόπουλου"
			},
			section_1: {
				title: "Bibliotheca Graeca",
				paragraph_1: "Η Συλλογή περιέχει όλες σχεδόν τις σημαντικές εκδόσεις, όλων των έργων που έχουν γραφτεί στα ελληνικά, ξεκινώντας από τον Όμηρο και τις απαρχές της ελληνικής γραμματείας, μέχρι την πτώση της Κωνσταντινούπολης το 1453. Τα θέματα που περιλαμβάνει αφορούν τη λογοτεχνία, φιλοσοφία και ιστορία, αλλά και τις φυσικές επιστήμες, τα μαθηματικά, την ιατρική, εκκλησιαστικά κείμενα και πολλά άλλα.",
				paragraph_2: "Η συλλογή είναι γνωστή ως Bibliotheca Graeca, ως εκ του τίτλου του ομώνυμου έργου του μεγάλου Γερμανού λόγιου και βιβλιογράφου του 18ου αιώνα Φαβρικίου (Johann Albert Fabricius, 1668-1736), ο οποίος χρησιμοποίησε τον όρο για να περιγράψει το σύνολο της ελληνικής γραμματείας, όπως διαφυλάχθηκε μέσω των χειρογράφων, των παπύρων και των επιγραφών.",
				button_1: "Ο ΣΥΛΛΕΚΤΗΣ Α. ΟΙΚΟΝΟΜΟΠΟΥΛΟΣ",
				button_2: "ΕΠΙΚΟΙΝΩΝΙΑ"
			},
			section_2: {
				title: "Κατάλογος της Συλλογής <br> & θησαυρός της γραμματείας",
				paragraph_1: "Η βάση δεδομένων που τίθεται στη διάθεση του κοινού με την παρούσα ιστοσελίδα περιλαμβάνει αναλυτικά όλους τους τίτλους των βιβλίων της συλλογής τα οποία μπορούν να αναζητηθούν με οποιοδήποτε στοιχείο της ταυτότητάς τους, όπως το όνομα του συγγραφέα, κάποια λέξη του τίτλου, τον εκδότη, τον χρόνο έκδοσης κλπ.",
				paragraph_2: "Μοναδικό χαρακτηριστικό της βάσης δεδομένων είναι οτι περιλαμβάνει φωτογραφικό υλικό για όλα τα βιβλία, στοιχείο που την καθιστά εργαλείο έρευνας και μελέτης.",
				paragraph_3: "Επιπλέον συνοδεύεται από έναν εγκυκλοπαιδικό θησαυρό που περιέχει πληροφορίες για τους βίους των συγγραφέων και το συγγραφικό τους έργο.",
				paragraph_4: "Με το κουμπί αναζήτησης παρακάτω μπορείτε να περιηγηθείτε σε όλο το εύρος και το βάθος της συλλογής, να ενημερωθείτε για λεπτομέρειες των εκδόσεων της γραμματείας και να αναζητήσετε τις πληροφορίες που σας ενδιαφέρουν.",
				button_1: "Αναζητηση"
			}
		},
		page_collector: {
			title: "ΒΙΟΓΡΑΦΙΚΟ ΣΗΜΕΙΩΜΑ του ΑΘΑΝΑΣΙΟΥ ΟΙΚΟΝΟΜΟΠΟΥΛΟΥ",
			paragraph_1: "Ο Αθανάσιος Οικονομόπουλος γεννήθηκε στη Θεσσαλονίκη το 1953",
			paragraph_2: "Κατέχει δίπλωμα μηχανολόγου-ηλεκτρολόγου από το Εθνικό Μετσόβιο Πολυτεχνείο Αθηνών και διδακτορικό (Diplôme de Docteur Ingénieur) από το πανεπιστήμιο Pierre et Marie Curie των Παρισίων.",
			paragraph_3: "Από το 1978 μέχρι το τέλος του 1980 εργάστηκε στο Εργαστήριο LIMSI του Γαλλικού Εθνικού Κέντρου Ερευνών (CNRS), από το 1980 έως το 1984 ως βοηθός καθηγητής στο Ομοσπονδιακό Πολυτεχνείο της Λωζάννης (École Polytecnique Fédérale de Lausanne) και από 1984 μέχρι το 1987 διηύθυνε το πιλοτικό πρόγραμμα ρομποτικής στα πλαίσια της δράσης ESPRIT της ΕΕ στις Βρυξέλλες.",
			paragraph_4: "Το 1998 ίδρυσε την εταιρεία ΖΕΝΟΝ robotics στην Ελλάδα και διετέλεσε διευθύνων σύμβουλος και πρόεδρος του ΔΣ μέχρι τον Ιούλιο του 2008 όταν και αποσύρθηκε οριστικά από τη διοίκηση και τη μετοχική της σύνθεση. Στην 20ετή εν λόγω πορεία της η ΖΗΝΩΝ υλοποίησε περισσότερα από 50 έργα εγκατάστασης ρομποτικών εφαρμογών στην Ελληνική βιομηχανία και περισσότερα από 100 ερευνητικά συμβόλαια με ξένες εταιρείες."
		},
		page_search: {
			title: "",
			code: "ΚΩΔΙΚΟΣ",
			category: "ΚΑΤΗΓΟΡΙΑ",
			author: "ΣΥΓΓΡΑΦΕΑΣ / ΚΑΛΛΙΤΕΧΝΗΣ",
			short_title: "ΣΥΝΟΠΤΙΚΟΣ ΤΙΤΛΟΣ",
			description: "ΠΕΡΙΓΡΑΦΗ",
			date_of_writing: "ΧΡ/ΓΙΑ ΣΥΓΓΡΑΦΗΣ:",
			example: "(e.g. –800 to –600)",
			from: "από",
			to: "έως",
			date_of_publication: "ΧΡ/ΓΙΑ ΕΚΔΟΣΗΣ:",
			place_of_writing: "Τόπος Συγγραφής",
			place_of_birth: "ΤΟΠΟΣ ΓΕΝΝΗΣΗΣ",
			result: "Αποτελέσματα"
		},
		single_card: {
			author: "Συγγραφέας/Καλλιτέχνης:",
			publisher: "Εκδότης:",
			category_of_Work: "Κατηγορία Έργου:",
			book_code: "Κωδικός Βιβλίου:"
		},
		page_book_profile: {
			title: "Εξώφυλλο",
			book_code: "Κωδικός Βιβλίου",
			btn_back: "Επιστροφή",
			btn_new_search: "Νέα αναζήτηση",
			description: "Περιγραφή"
		},
		page_thesaurus: {
			title: "",
			btn_back: "Επιστροφή",
			description: "Περιγραφή",
			wikipedia: "Wikipedia",
			dictionary: "Λεξικό ΣΟΥΔΑΣ"
		}
	}
}
